import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import DialogDefaultAction from "../../atoms/DialogDefaultAction";

interface MoveScopeDialogProps {
  open: boolean;
  onCancel: () => void;
  onAll: () => void;
  onSingle: () => void;
}

/**
 * "Alle oder nur diese?" — the scope prompt shown before a multi-slot
 * appointment is lifted onto the shelf via the context menu's Umziehen (both
 * menu variants render it). The keyboard flow never prompts: plain v grabs
 * the whole appointment, Shift+V grabs a single slot (see calendarHotkeys).
 */
const MoveScopeDialog = ({ open, onCancel, onAll, onSingle }: MoveScopeDialogProps) => (
  <Dialog open={open} onClose={onCancel}>
    <DialogDefaultAction onAction={onSingle} disabled={!open} />
    <DialogTitle>Termin verschieben</DialogTitle>
    <DialogContent>
      Möchtest du alle mit diesem Termin verknüpften Behandlungen verschieben oder nur die
      ausgewählte Behandlung?
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel}>Abbrechen</Button>
      <Button onClick={onAll}>Alle</Button>
      <Button onClick={onSingle} color="primary" autoFocus>
        Nur diese
      </Button>
    </DialogActions>
  </Dialog>
);

export default MoveScopeDialog;
